type TicketForm =
  | 'submit_issue'
  | 'help_with_whatsapp_setup'
  | 'purchase_a_mobile_number'
  | 'help_with_sms_setup'
  | 'help_with_email_setup'
  | 'request_a_change_to_opening_messages'
  | 'reporting_request'
  | 'submit_product_feedback';

const PYLON_BASE_URL = 'https://portal.usepylon.com/popp/forms';

const formPathMap: Record<TicketForm, string> = {
  help_with_email_setup: 'help-with-email-setup',
  help_with_sms_setup: 'help-with-sms-setup',
  help_with_whatsapp_setup: 'help-with-whatsapp-setup',
  reporting_request: 'reporting-request',
  request_a_change_to_opening_messages: 'request-a-change-to-opening-messages',
  submit_issue: 'submit-issue',
  submit_product_feedback: 'submit-product-feedback',
  purchase_a_mobile_number: 'submit-issue' // Fallback - no dedicated form for purchase_a_mobile_number
};

export const getSupportUrl = ({ ticketForm }: { ticketForm: TicketForm }) =>
  `${PYLON_BASE_URL}/${formPathMap[ticketForm]}`;

export const openSupportUrl = ({
  ticketForm = 'submit_issue'
}: {
  ticketForm: TicketForm;
}) => {
  window.open(getSupportUrl({ ticketForm }), '_blank');
};
